import { getFontSize } from "../../constants/fontSizes";

export const propertyCardStyles = () => {
  return {
    container: {
      borderWidth: '0px',
      borderStyle: 'solid',
      borderColor: '#BABABA80',
      width: {lg: '430px', xs: '275px'},
      height: {lg: '600px', xs: 'auto'},
      borderRadius: '50px',
      display: 'flex',
      flexDirection: 'column',
      padding: '0px',
      position: 'relative',
      backgroundColor: '#FFFFFF',
    },
    imageContainer: {
      position: 'relative',
      margin: '10px',
      marginBottom: '20px',
      width: {lg: '410px', xs: '260px'},
      height: {lg: '357px', xs: '230px'},
    },
    image: {
      width: {lg: '410px', xs: '260px'},
      height: {lg: '357px', xs: '230px'},
      borderRadius: '50px',
      objectFit: 'cover',
    },
    iconButton: {
      position: 'absolute',
      top: {xs: '20px', lg: '10px'},
      right: {xs: '20px', lg: '10px'},
      width: {xs: '38px', lg: '50px'},
      height: {xs: '38px', lg: '50px'},
      backgroundColor: '#000000',
      borderRadius: '50%',
      padding: 0,
      '&:hover': {
        backgroundColor: '#000000',
        opacity: 0.8,
      },
    },
    arrowIcon: {
      color: '#FFFFFF',
      fontSize: {xs: '18px', lg: '24px'},
    },
    buildingRow: {
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      gap: '12px',
      paddingLeft: {xs: '10px', lg: '30px'},
      paddingRight: {xs: '10px', lg: '20px'},
      marginBottom: {xs: '5px', lg: '10px'},
    },
    buildingIconContainer: {
      width: {xs: '38px', lg: '54px'},
      height: {xs: '38px', lg: '54px'},
      borderRadius: '50%',
      border: '1px solid #BABABA80',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      flexShrink: 0,
    },
    buildingIcon: {
      width: '18px',
      height: '18px',
      objectFit: 'contain',
    },
    buildingTextContainer: {
      display: 'flex',
      flexDirection: 'column',
      gap: '4px',
    },
    buildingTitle: {
      fontFamily: 'Lato',
      fontWeight: 600,
      fontSize: getFontSize(17),
      lineHeight: getFontSize(17),
      color: '#181717',
    },
    buildingSubtitle: {
      fontFamily: 'Lato',
      fontWeight: 400,
      fontSize: getFontSize(17),
      lineHeight: "20px",
      color: '#818181',
    },
    priceRow: {
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      gap: '8px',
      paddingLeft: {xs: '10px', lg: '30px'},
      paddingRight: '20px',
      marginBottom: {lg: '10px', xs: '5px'},
    },
    price: {
      fontFamily: 'Lato',
      fontWeight: 500,
      fontSize: getFontSize(30),
      lineHeight: {xs: "20px", lg: "60px"},
      color: '#181717',
    },
    currency: {
      fontFamily: 'Lato',
      fontWeight: 500,
      fontSize: getFontSize(16),
      lineHeight: {xs: "20px", lg: "60px"},
      color: '#181717',
    },
    perNight: {
      fontFamily: 'Lato',
      fontWeight: 500,
      fontSize: '16px',
      lineHeight: '60px',
      color: '#181717',
    },
    chipsContainer: {
      display: 'flex',
      flexDirection: 'row',
      gap: {xs: '5px', lg: '10px'},
      paddingLeft: {xs: '15px', lg: '30px'},
      paddingRight: {xs: '15px', lg: '20px'},
      flexWrap: 'wrap',
      paddingBottom: {xs: '25px', lg: '0px'},
    },
    chip: {
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      gap: {xs: '4px', lg: '6px'},
      borderRadius: '50px',
      border: '1px solid #BABABA80',
      padding: {xs: '5px', lg: '15px'},
    
    },
    chipIcon: {
      width: '18px',
      height: '18px',
      color: '#181717',
      objectFit: 'contain',
    },
    chipText: {
      fontFamily: 'Lato',
      fontWeight: 400,
      fontSize: getFontSize(16),
      lineHeight: '20px',
      color: '#181717',
    },
  };
};

